// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-page {
    margin: 0 auto;
    max-width: 1440px;
    min-height: 58vh;
    padding: 0 28px 112px;
}

.about-editorial { background: #fff; color: var(--mg-ink); }

.about-editorial__hero { height: clamp(560px, calc(100svh - 126px), 820px); overflow: hidden; position: relative; }

.about-editorial__hero > img { filter: grayscale(1); height: 100%; object-fit: cover; position: absolute; width: 100%; }

.about-editorial__shade { background: linear-gradient(0deg, rgba(0,0,0,.58), rgba(0,0,0,.06) 70%); inset: 0; position: absolute; }

.about-editorial__hero-copy { align-items: center; color: #fff; display: flex; flex-direction: column; inset: 0; justify-content: center; padding: 28px; position: absolute; text-align: center; }

.about-editorial__hero-copy p,
.about-editorial__hero-copy span,
.about-editorial__kicker { font-size: 10px; font-weight: 600; letter-spacing: .16em; text-transform: uppercase; }

.about-editorial__hero-copy h1 { font-family: var(--mg-serif); font-size: clamp(3.4rem, 8vw, 8.5rem); font-weight: 400; line-height: .82; margin: 26px 0 30px; }

.about-editorial__statement { margin: 0 auto; max-width: 1160px; padding: clamp(72px, 10vw, 144px) 32px; text-align: center; }

.about-editorial__statement p { font-family: var(--mg-serif); font-size: clamp(2rem, 4vw, 4.5rem); line-height: 1.06; margin: 0; }

.about-editorial__story { background: #f1f1f1; display: grid; grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr); }

.about-editorial__story-copy { align-self: center; padding: clamp(48px, 7vw, 108px); }

.about-editorial__kicker { margin: 0 0 40px; }

.about-editorial__chapter { border-top: 1px solid var(--mg-line); display: grid; gap: 20px; grid-template-columns: 28px minmax(0, 1fr); padding: 28px 0 32px; }

.about-editorial__chapter > span { color: #777; font-size: 10px; }

.about-editorial__chapter h2 { font-family: var(--mg-serif); font-size: clamp(1.8rem, 3vw, 3.4rem); font-weight: 400; line-height: 1; margin: 0 0 18px; }

.about-editorial__chapter p,
.about-editorial__chapter li { font-size: 14px; line-height: 1.65; }

.about-editorial__chapter p { margin: 0; }

.about-editorial__chapter ul { display: grid; gap: 8px; margin: 18px 0 0; padding-left: 18px; }

.about-editorial__media { min-height: 760px; }

.about-editorial__media img { height: 100%; object-fit: cover; width: 100%; }

.about-editorial__closing { align-items: center; display: flex; justify-content: space-between; padding: clamp(56px, 8vw, 112px) clamp(24px, 7vw, 108px); }

.about-editorial__closing p { font-family: var(--mg-serif); font-size: clamp(2rem, 4vw, 4.5rem); line-height: 1; margin: 0; max-width: 850px; }

.about-editorial__closing a { border-bottom: 1px solid currentColor; color: inherit; flex: 0 0 auto; font-size: 12px; margin-left: 48px; padding: 12px 0; text-decoration: none; text-transform: uppercase; }

.info-page__hero {
    border-bottom: 1px solid var(--mg-line);
    padding: clamp(52px, 8vw, 112px) 0 clamp(44px, 6vw, 80px);
}

.info-page__eyebrow {
    color: #6a6762;
    font-size: 11px;
    letter-spacing: 0.16em;
    margin-bottom: 20px;
    text-transform: uppercase;
}

.info-page__title {
    font-family: var(--mg-serif);
    font-size: clamp(2.8rem, 6vw, 6.5rem);
    font-weight: 400;
    line-height: .95;
    margin: 0;
    max-width: 1050px;
}

.info-page__summary {
    color: #4f4c48;
    font-size: clamp(15px, 1.3vw, 18px);
    line-height: 1.65;
    margin: 28px 0 0;
    max-width: 720px;
}

.info-page__layout {
    display: grid;
    gap: clamp(48px, 8vw, 128px);
    grid-template-columns: minmax(220px, 280px) minmax(0, 760px);
    padding-top: 48px;
}

.info-page__aside { align-self: start; position: sticky; top: 132px; }

.info-page__aside-title,
.info-page__contact-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .14em;
    margin: 0 0 18px;
    text-transform: uppercase;
}

.info-page__nav { border-top: 1px solid var(--mg-line); display: grid; }

.info-page__nav a {
    border-bottom: 1px solid var(--mg-line);
    color: inherit;
    font-size: 13px;
    padding: 14px 0;
    text-decoration: none;
}

.info-page__nav a:hover,
.info-page__nav a.is-active { text-decoration: underline; text-underline-offset: 5px; }

.info-page__nav a.is-active { font-weight: 600; }

.info-page__contact {
    background: #f2f2f2;
    display: grid;
    font-size: 12px;
    gap: 8px;
    margin-top: 32px;
    padding: 24px;
}

.info-page__contact-label { margin-bottom: 4px; }

.info-page__contact a { color: inherit; text-decoration: none; }

.info-page__contact a:hover { text-decoration: underline; }

.info-page__content {
    border-top: 1px solid var(--mg-line);
    color: #4f4c48;
    font-size: 15px;
    line-height: 1.7;
    max-width: none;
}

.info-page__section {
    border-bottom: 1px solid var(--mg-line);
    display: grid;
    gap: 24px;
    grid-template-columns: 40px minmax(0, 1fr);
    padding: 32px 0 36px;
}

.info-page__section-number {
    color: #8a8a8a;
    font-size: 10px;
    letter-spacing: .12em;
}

.info-page__section h2 {
    color: #171717;
    font-family: var(--mg-serif);
    font-size: clamp(1.65rem, 2.5vw, 2.5rem);
    font-weight: 400;
    line-height: 1.05;
    margin: 0 0 20px;
}

.info-page__section p {
    margin: 0 0 16px;
}

.info-page__section ol {
    display: grid;
    gap: 12px;
    margin: 0;
    padding-left: 22px;
}

.info-page__section > :last-child {
    margin-bottom: 0;
}

@media (max-width: 640px) {
    .about-editorial__hero { height: calc(100svh - 132px); min-height: 560px; }

    .about-editorial__hero > img { object-position: 48% center; }

    .about-editorial__hero-copy h1 { font-size: clamp(3rem, 16vw, 4.5rem); }

    .about-editorial__statement { padding: 72px 20px; }

    .about-editorial__story { grid-template-columns: 1fr; }

    .about-editorial__story-copy { padding: 56px 20px; }

    .about-editorial__media { min-height: 125vw; }

    .about-editorial__closing { align-items: flex-start; flex-direction: column; gap: 30px; padding: 64px 20px; }

    .about-editorial__closing a { margin-left: 0; }

    .info-page {
        padding: 0 18px 72px;
    }

    .info-page__hero { padding: 44px 0 40px; }

    .info-page__title { font-size: clamp(2.4rem, 13vw, 4rem); }

    .info-page__summary { font-size: 15px; margin-top: 22px; }

    .info-page__layout { gap: 40px; grid-template-columns: 1fr; padding-top: 28px; }

    .info-page__aside { position: static; }

    .info-page__nav { grid-template-columns: repeat(2, minmax(0, 1fr)); }

    .info-page__nav a { padding-right: 12px; }

    .info-page__contact { margin-top: 24px; }

    .info-page__section { gap: 12px; grid-template-columns: 28px minmax(0, 1fr); padding: 26px 0 30px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoPage/InfoPage.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,mBAAmB,gBAAgB,EAAE,oBAAoB,EAAE;;AAE3D,yBAAyB,iDAAiD,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAElH,+BAA+B,oBAAoB,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,WAAW,EAAE;;AAEvH,0BAA0B,uEAAuE,EAAE,QAAQ,EAAE,kBAAkB,EAAE;;AAEjI,8BAA8B,mBAAmB,EAAE,WAAW,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,uBAAuB,EAAE,aAAa,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;;AAEjM;;2BAE2B,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;;AAEhH,iCAAiC,4BAA4B,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE/J,8BAA8B,cAAc,EAAE,iBAAiB,EAAE,sCAAsC,EAAE,kBAAkB,EAAE;;AAE7H,gCAAgC,4BAA4B,EAAE,mCAAmC,EAAE,iBAAiB,EAAE,SAAS,EAAE;;AAEjI,0BAA0B,mBAAmB,EAAE,aAAa,EAAE,uDAAuD,EAAE;;AAEvH,+BAA+B,kBAAkB,EAAE,gCAAgC,EAAE;;AAErF,2BAA2B,gBAAgB,EAAE;;AAE7C,4BAA4B,oCAAoC,EAAE,aAAa,EAAE,SAAS,EAAE,0CAA0C,EAAE,oBAAoB,EAAE;;AAE9J,mCAAmC,WAAW,EAAE,eAAe,EAAE;;AAEjE,+BAA+B,4BAA4B,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAExJ;+BAC+B,eAAe,EAAE,iBAAiB,EAAE;;AAEnE,8BAA8B,SAAS,EAAE;;AAEzC,+BAA+B,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE9F,0BAA0B,iBAAiB,EAAE;;AAE7C,8BAA8B,YAAY,EAAE,iBAAiB,EAAE,WAAW,EAAE;;AAE5E,4BAA4B,mBAAmB,EAAE,aAAa,EAAE,8BAA8B,EAAE,wDAAwD,EAAE;;AAE1J,8BAA8B,4BAA4B,EAAE,mCAAmC,EAAE,cAAc,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAE9I,8BAA8B,qCAAqC,EAAE,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;;AAE5M;IACI,uCAAuC;IACvC,yDAAyD;AAC7D;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,4DAA4D;IAC5D,iBAAiB;AACrB;;AAEA,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,UAAU,EAAE;;AAErE;;IAEI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,kBAAkB,oCAAoC,EAAE,aAAa,EAAE;;AAEvE;IACI,uCAAuC;IACvC,cAAc;IACd,eAAe;IACf,eAAe;IACf,qBAAqB;AACzB;;AAEA;8BAC8B,0BAA0B,EAAE,0BAA0B,EAAE;;AAEtF,8BAA8B,gBAAgB,EAAE;;AAEhD;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,aAAa;AACjB;;AAEA,4BAA4B,kBAAkB,EAAE;;AAEhD,wBAAwB,cAAc,EAAE,qBAAqB,EAAE;;AAE/D,8BAA8B,0BAA0B,EAAE;;AAE1D;IACI,oCAAoC;IACpC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,SAAS;IACT,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,4BAA4B,EAAE,iBAAiB,EAAE;;IAE1E,+BAA+B,2BAA2B,EAAE;;IAE5D,iCAAiC,oCAAoC,EAAE;;IAEvE,8BAA8B,kBAAkB,EAAE;;IAElD,0BAA0B,0BAA0B,EAAE;;IAEtD,+BAA+B,kBAAkB,EAAE;;IAEnD,0BAA0B,iBAAiB,EAAE;;IAE7C,4BAA4B,uBAAuB,EAAE,sBAAsB,EAAE,SAAS,EAAE,kBAAkB,EAAE;;IAE5G,8BAA8B,cAAc,EAAE;;IAE9C;QACI,oBAAoB;IACxB;;IAEA,mBAAmB,oBAAoB,EAAE;;IAEzC,oBAAoB,oCAAoC,EAAE;;IAE1D,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;;IAEzD,qBAAqB,SAAS,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;;IAE/E,oBAAoB,gBAAgB,EAAE;;IAEtC,kBAAkB,gDAAgD,EAAE;;IAEpE,oBAAoB,mBAAmB,EAAE;;IAEzC,sBAAsB,gBAAgB,EAAE;;IAExC,sBAAsB,SAAS,EAAE,0CAA0C,EAAE,oBAAoB,EAAE;AACvG","sourcesContent":[".info-page {\n    margin: 0 auto;\n    max-width: 1440px;\n    min-height: 58vh;\n    padding: 0 28px 112px;\n}\n\n.about-editorial { background: #fff; color: var(--mg-ink); }\n\n.about-editorial__hero { height: clamp(560px, calc(100svh - 126px), 820px); overflow: hidden; position: relative; }\n\n.about-editorial__hero > img { filter: grayscale(1); height: 100%; object-fit: cover; position: absolute; width: 100%; }\n\n.about-editorial__shade { background: linear-gradient(0deg, rgba(0,0,0,.58), rgba(0,0,0,.06) 70%); inset: 0; position: absolute; }\n\n.about-editorial__hero-copy { align-items: center; color: #fff; display: flex; flex-direction: column; inset: 0; justify-content: center; padding: 28px; position: absolute; text-align: center; }\n\n.about-editorial__hero-copy p,\n.about-editorial__hero-copy span,\n.about-editorial__kicker { font-size: 10px; font-weight: 600; letter-spacing: .16em; text-transform: uppercase; }\n\n.about-editorial__hero-copy h1 { font-family: var(--mg-serif); font-size: clamp(3.4rem, 8vw, 8.5rem); font-weight: 400; line-height: .82; margin: 26px 0 30px; }\n\n.about-editorial__statement { margin: 0 auto; max-width: 1160px; padding: clamp(72px, 10vw, 144px) 32px; text-align: center; }\n\n.about-editorial__statement p { font-family: var(--mg-serif); font-size: clamp(2rem, 4vw, 4.5rem); line-height: 1.06; margin: 0; }\n\n.about-editorial__story { background: #f1f1f1; display: grid; grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr); }\n\n.about-editorial__story-copy { align-self: center; padding: clamp(48px, 7vw, 108px); }\n\n.about-editorial__kicker { margin: 0 0 40px; }\n\n.about-editorial__chapter { border-top: 1px solid var(--mg-line); display: grid; gap: 20px; grid-template-columns: 28px minmax(0, 1fr); padding: 28px 0 32px; }\n\n.about-editorial__chapter > span { color: #777; font-size: 10px; }\n\n.about-editorial__chapter h2 { font-family: var(--mg-serif); font-size: clamp(1.8rem, 3vw, 3.4rem); font-weight: 400; line-height: 1; margin: 0 0 18px; }\n\n.about-editorial__chapter p,\n.about-editorial__chapter li { font-size: 14px; line-height: 1.65; }\n\n.about-editorial__chapter p { margin: 0; }\n\n.about-editorial__chapter ul { display: grid; gap: 8px; margin: 18px 0 0; padding-left: 18px; }\n\n.about-editorial__media { min-height: 760px; }\n\n.about-editorial__media img { height: 100%; object-fit: cover; width: 100%; }\n\n.about-editorial__closing { align-items: center; display: flex; justify-content: space-between; padding: clamp(56px, 8vw, 112px) clamp(24px, 7vw, 108px); }\n\n.about-editorial__closing p { font-family: var(--mg-serif); font-size: clamp(2rem, 4vw, 4.5rem); line-height: 1; margin: 0; max-width: 850px; }\n\n.about-editorial__closing a { border-bottom: 1px solid currentColor; color: inherit; flex: 0 0 auto; font-size: 12px; margin-left: 48px; padding: 12px 0; text-decoration: none; text-transform: uppercase; }\n\n.info-page__hero {\n    border-bottom: 1px solid var(--mg-line);\n    padding: clamp(52px, 8vw, 112px) 0 clamp(44px, 6vw, 80px);\n}\n\n.info-page__eyebrow {\n    color: #6a6762;\n    font-size: 11px;\n    letter-spacing: 0.16em;\n    margin-bottom: 20px;\n    text-transform: uppercase;\n}\n\n.info-page__title {\n    font-family: var(--mg-serif);\n    font-size: clamp(2.8rem, 6vw, 6.5rem);\n    font-weight: 400;\n    line-height: .95;\n    margin: 0;\n    max-width: 1050px;\n}\n\n.info-page__summary {\n    color: #4f4c48;\n    font-size: clamp(15px, 1.3vw, 18px);\n    line-height: 1.65;\n    margin: 28px 0 0;\n    max-width: 720px;\n}\n\n.info-page__layout {\n    display: grid;\n    gap: clamp(48px, 8vw, 128px);\n    grid-template-columns: minmax(220px, 280px) minmax(0, 760px);\n    padding-top: 48px;\n}\n\n.info-page__aside { align-self: start; position: sticky; top: 132px; }\n\n.info-page__aside-title,\n.info-page__contact-label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: .14em;\n    margin: 0 0 18px;\n    text-transform: uppercase;\n}\n\n.info-page__nav { border-top: 1px solid var(--mg-line); display: grid; }\n\n.info-page__nav a {\n    border-bottom: 1px solid var(--mg-line);\n    color: inherit;\n    font-size: 13px;\n    padding: 14px 0;\n    text-decoration: none;\n}\n\n.info-page__nav a:hover,\n.info-page__nav a.is-active { text-decoration: underline; text-underline-offset: 5px; }\n\n.info-page__nav a.is-active { font-weight: 600; }\n\n.info-page__contact {\n    background: #f2f2f2;\n    display: grid;\n    font-size: 12px;\n    gap: 8px;\n    margin-top: 32px;\n    padding: 24px;\n}\n\n.info-page__contact-label { margin-bottom: 4px; }\n\n.info-page__contact a { color: inherit; text-decoration: none; }\n\n.info-page__contact a:hover { text-decoration: underline; }\n\n.info-page__content {\n    border-top: 1px solid var(--mg-line);\n    color: #4f4c48;\n    font-size: 15px;\n    line-height: 1.7;\n    max-width: none;\n}\n\n.info-page__section {\n    border-bottom: 1px solid var(--mg-line);\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 40px minmax(0, 1fr);\n    padding: 32px 0 36px;\n}\n\n.info-page__section-number {\n    color: #8a8a8a;\n    font-size: 10px;\n    letter-spacing: .12em;\n}\n\n.info-page__section h2 {\n    color: #171717;\n    font-family: var(--mg-serif);\n    font-size: clamp(1.65rem, 2.5vw, 2.5rem);\n    font-weight: 400;\n    line-height: 1.05;\n    margin: 0 0 20px;\n}\n\n.info-page__section p {\n    margin: 0 0 16px;\n}\n\n.info-page__section ol {\n    display: grid;\n    gap: 12px;\n    margin: 0;\n    padding-left: 22px;\n}\n\n.info-page__section > :last-child {\n    margin-bottom: 0;\n}\n\n@media (max-width: 640px) {\n    .about-editorial__hero { height: calc(100svh - 132px); min-height: 560px; }\n\n    .about-editorial__hero > img { object-position: 48% center; }\n\n    .about-editorial__hero-copy h1 { font-size: clamp(3rem, 16vw, 4.5rem); }\n\n    .about-editorial__statement { padding: 72px 20px; }\n\n    .about-editorial__story { grid-template-columns: 1fr; }\n\n    .about-editorial__story-copy { padding: 56px 20px; }\n\n    .about-editorial__media { min-height: 125vw; }\n\n    .about-editorial__closing { align-items: flex-start; flex-direction: column; gap: 30px; padding: 64px 20px; }\n\n    .about-editorial__closing a { margin-left: 0; }\n\n    .info-page {\n        padding: 0 18px 72px;\n    }\n\n    .info-page__hero { padding: 44px 0 40px; }\n\n    .info-page__title { font-size: clamp(2.4rem, 13vw, 4rem); }\n\n    .info-page__summary { font-size: 15px; margin-top: 22px; }\n\n    .info-page__layout { gap: 40px; grid-template-columns: 1fr; padding-top: 28px; }\n\n    .info-page__aside { position: static; }\n\n    .info-page__nav { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n\n    .info-page__nav a { padding-right: 12px; }\n\n    .info-page__contact { margin-top: 24px; }\n\n    .info-page__section { gap: 12px; grid-template-columns: 28px minmax(0, 1fr); padding: 26px 0 30px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
